<template>
  <transition name="fade">
    <div class="level3-modal-container">
      <div class="lv3-title-text">SIO</div>
      <div class="lv3-edit-form">
        <div>Bisnis Unit</div>
        <div class="half-input-wrapper">
          <div class="hiw-full">
            <label class="hiw-3-row"
              ><input
                type="radio"
                v-model="bisnis_unit"
                value="GEMS"
                style="margin-right: 10px"
              />GEMS</label
            >
            <label class="hiw-3-row"
              ><input
                type="radio"
                v-model="bisnis_unit"
                value="BCE"
                style="margin-right: 10px"
              />BCE</label
            >
            <label class="hiw-3-row"
              ><input
                type="radio"
                v-model="bisnis_unit"
                value="BKES"
                style="margin-right: 10px"
              />BKES</label
            >
          </div>
        </div>
        <div class="edit-form-wrapper">
          <div>Nomor</div>
          <input class="lv3-input-text" type="text" v-model="nomor" />
        </div>
        <div class="edit-form-wrapper">
          <div>Kegiatan</div>
          <input class="lv3-input-text" type="text" v-model="kegiatan" />
        </div>

        <div class="edit-form-wrapper">
          <div>Area Kerja</div>
          <input class="lv3-input-text" type="text" v-model="area_kerja" />
        </div>
        <div class="edit-form-wrapper">
          <div>Nama PJO</div>
          <input class="lv3-input-text" type="text" v-model="nama_pjo" />
        </div>
        <div class="edit-form-wrapper">
          <div>Email PJO</div>
          <input class="lv3-input-text" type="text" v-model="email_pjo" />
        </div>
        <div class="edit-form-wrapper">
          <div>Perusahaan Penanggung</div>
          <input class="lv3-input-text" type="text" v-model="departemen_pjo" />
        </div>
        <div class="form-date-wrapper">
          <div class="edit-form-wrapper">
            <div>Tanggal Mulai</div>
            <input class="lv3-input-date" type="date" v-model="start_date" />
          </div>
          <div class="edit-form-wrapper">
            <div>Tanggal Berakhir</div>
            <input class="lv3-input-date" type="date" v-model="end_date" />
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div
            class="email-button"
            @click="submitDoc($store.state.editStore.k3lDetail.id)"
          >
            CONFIRM
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      bisnis_unit: '',
      nomor: '',
      kegiatan: '',
      area_kerja: '',
      nama_pjo: '',
      email_pjo: '',
      departemen_pjo: '',
      start_date: '',
      end_date: '',
    }
  },
  computed: {},
  methods: {
    checkForm() {
      let arr = [
        [this.bisnis_unit, 'Binis Unit'],
        [this.nomor, 'Nomor'],
        [this.kegiatan, 'Kegiatan'],
        [this.area_kerja, 'Area Kerja'],
        [this.nama_pjo, 'Nama PJO'],
        [this.isEmailValid(this.email_pjo), 'Email PJO'],
        [this.departemen_pjo, 'Departemen PJO'],
      ]

      return this.multiConditions(arr)
    },
    submitDoc(id) {
      if (this.checkForm()) {
        let request = {
          vendor_id: this.$store.state.level1.vendorId,
          bisnis_unit: this.bisnis_unit,
          nomor: this.nomor,
          kegiatan: this.kegiatan,
          area_kerja: this.area_kerja,
          nama_pjo: this.nama_pjo,
          email_pjo: this.email_pjo,
          departemen_pjo: this.departemen_pjo,
        }

        if (this.start_date) {
          request['start_date'] = this.start_date
        }

        if (this.end_date) {
          request['end_date'] = this.end_date
        }

        this.$store.dispatch('editStore/updateSio', request)
      }
    },
    closeModal() {
      const self = this
      self.$store.commit('modalStore/CLOSE_SIO')
    },
    fileChangeHandler(e) {
      this.files = Array.from(e.target.files)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
